<template>
  <v-container>
    <v-form ref="form" @submit.prevent="submit">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-img min-height="320" src="@/assets/image/Nekologic.png">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <br />
          <v-card color="secondary" elevation="24">
            <v-container>
              <h1
                style="
                  color: yellow;
                  font-weight: bold;
                  margin: 20px;
                  text-align: center;
                "
              >
                REGISTER TO NEKOHR
              </h1>
              <b-alert show="" :variant="status.type" v-if="status"
                >{{ status.message }}
              </b-alert>
              <v-text-field
                v-model="fName"
                required
                placeholder="Enter your First Name"
                type="text"
                background-color="white"
                color="red"
                solo
              >
                <v-icon slot="prepend" color="yellow"
                  >mdi-account
                </v-icon></v-text-field
              >
              <v-text-field
                v-model="lName"
                required
                placeholder="Enter your Last Name"
                type="text"
                background-color="white"
                color="red"
                solo
              >
                <v-icon slot="prepend" color="yellow"
                  >mdi-account
                </v-icon></v-text-field
              >
              <v-text-field
                v-model="email"
                required
                label="Email"
                placeholder="Enter your Email Address"
                type="text"
                background-color="white"
                color="red"
                solo
              >
                <v-icon slot="prepend" color="yellow">mdi-email </v-icon>
              </v-text-field>
              <v-text-field
                v-model="username"
                required
                placeholder="Enter your Username"
                type="text"
                background-color="white"
                color="red"
                solo
              >
                <v-icon slot="prepend" color="yellow">mdi-account </v-icon>
              </v-text-field>
              <v-text-field
                v-model="password"
                required
                placeholder="Enter new Password"
                type="password"
                solo
                background-color="white"
                color="red"
              >
                <v-icon slot="prepend" color="yellow"
                  >mdi-key
                </v-icon></v-text-field
              >
              <v-text-field
                v-model="confPassword"
                required
                placeholder="Repeat new Password"
                type="password"
                solo
                background-color="white"
                color="red"
              >
                <v-icon slot="prepend" color="yellow"
                  >mdi-key
                </v-icon></v-text-field
              >
              <v-card-actions>
                <v-btn type="submit" tile class="ml-8" large color="yellow"
                  >Register</v-btn
                >
                <v-btn @click="cancel" tile large color="primary">Cancel</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
export default {
  name: "Register",
  components: {},
  data() {
    return {
      email_address: "",
      username: "",
      password: "",
      confPassword: "",
      first_name: "",
      last_name: "",
      status: "",
    };
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "REGISTER_USER_REQUEST",
    ]),
    onSubmit() {
      this.register();
    },
    async register() {
      try {
        const {email_address, username, password, full_name, last_name} = this;
        await this.showLoadingProcess();
        await this.REGISTER_USER_REQUEST({
          email_address,
          username,
          password,
          full_name,
          last_name,
        });
        this.status = {
          type: "success",
          message: "Registrations Successful!!!!",
        };
      } catch (err) {
        console.log(`registration error: ${err}`);
      } finally {
        await this.closeLoading();
      }
    },
    cancel() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped></style>
